import axios from "axios";
let token;
const tokenExpiration = localStorage.getItem("token_expiration");
const currentTime = new Date().getTime();

if (tokenExpiration && currentTime < tokenExpiration) {
  console.log("token is valid");
  // Token is still valid
  token = localStorage.getItem("token");
} else {
  // Token expired, clear it and redirect to login
  localStorage.removeItem("token");
  localStorage.removeItem("token_expiration");
}

export const postJsonHelper = async (url, payload) => {
  try {
    const response = await axios.post(url, payload);
    console.log("postjson", response);
    return response;
  } catch (err) {
    console.log("error in postJSONAPI", err);
    return err.response.data;
  }
};

export const postJsonHelperWithToken = async (url, payload) => {
  try {
    const response = await axios.post(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    console.log("error in postJSONAPI", err);
    throw err;
  }
};

export const getJsonHelper = async (url, params) => {
  if (token === null) {
    console.log("Token not found");
    return;
  }
  try {
    let finalUrl = params ? `${url}/${params}` : url;
    const response = await axios.get(finalUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    console.log("error in getJSONAPI", err);
    throw err;
  }
};

export const postFormDataHelper = async (url, payload) => {
  try {
    const response = await axios.post(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (err) {
    console.log("error in postFormDataAPI", err);
    throw err;
  }
};

export const deleteJsonHelperWithToken = async (url) => {
  try {
    const response = await axios.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (err) {
    console.log("error in deleteJSONAPI", err);
    throw err;
  }
};
